import { Button, SvgIcon } from '@mui/material'
import { IconArrowNarrowLeft } from '@tabler/icons-react'
import { useNavigate } from 'react-router'

export const GoBackButton = ({ route, text }: { route?: string; text?: string }) => {
  const navigate = useNavigate()

  return (
    <Button
      sx={{ alignSelf: 'flex-start', mb: 2, textTransform: 'unset' }}
      startIcon={
        <SvgIcon>
          <IconArrowNarrowLeft />
        </SvgIcon>
      }
      variant="text"
      onClick={() => (route ? navigate(route) : navigate(-1))}
    >
      {text ?? 'Go back'}
    </Button>
  )
}
